import React, { useLayoutEffect, useState } from "react";
import Select from "react-select";
import { ListButton, useTranslate } from "react-admin";
import { Papa } from "../common/common";

import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  DigitalOrderSystem,
  EmptyPagination,
} from "../common/common";
import Swal from "sweetalert2";
import Modal from "react-responsive-modal";
import { useNavigate } from "react-router-dom";

const BulkSendMessageCreate = (props) => {
  const translate = useTranslate();
  const navigate = useNavigate();

  const [showLoader, setShowLoader] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [validationPurposeError, setValidationPurposeError] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMsgText, setErrorMsgText] = useState(null);
  const [type, setType] = useState("Business");
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [parsedCSVdata, setParsedCSVdata] = useState([]);
  const [unregisteredRetailers, setUnregisteredRetailers] = useState([]);
  const [pasrsedSimilarDataLength, setPasrsedSimilarDataLength] = useState(0);
  const [pasrsedDifferentDataLength, setPasrsedDifferentDataLength] =
    useState(0);
  const [unregisteredRetailersToggle, setUnregisteredRetailersToggle] =
    useState(false);
  const [saleOffList, setSaleOffList] = useState([]);
  const [messageCount, setMessageCount] = useState(0);
  const [showFileError, setShowFileError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [inAppPurpose, setInAppPurpose] = useState("");

  useLayoutEffect(() => {
    // const { props, state } = this;
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/so_business_list`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;
        // console.log('obj==>', obj);
        setOriginalList(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
        setSaleOffNameSapCode(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
      });
  }, []);

  const purposeChange = (e) => {
    console.log("e >>>>>>>>>", e.target.value);
    if (
      e.target.value === "" ||
      e.target.value === undefined ||
      e.target.value === null ||
      !e.target.value.trim().length
    ) {
      setValidationError(true);
      setValidationPurposeError(true);
    } else {
      setValidationError(false);
      setValidationPurposeError(false);
    }
    setInAppPurpose(e.target.value);
  };

  const formSave = () => {
    setShowLoader(true);
    setSaveButtonDisabled(false);
    const formData = {
      // title: inAppTitle.trim(),
      // description: this.state.inAppDescription.trim(),
      type: type,
      name_sap_code: saleOffList,
      purpose: inAppPurpose.trim(),
    };
    console.log("formData>>>>>>", formData);

    const apiUrl = RUN_TIME_API_ENDPOINT;
    const options = CommonHeaderOption();
    options.method = "POST";
    options.body = JSON.stringify({ formData });

    return fetch(`${apiUrl}/send_sms_bulk_notifications`, options)
      .then((res) => {
        console.log("res12...........", res);
        if (res) {
          return res.json();
        }
      })
      .then((res) => {
        if (res.errorMsg) {
          setShowModal(false);
          setErrorMsg(true);
          setShowLoader(false);
          setErrorMsgText(res.errorMsg);

          setTimeout(() => {
            setErrorMsg(false);
            setSaveButtonDisabled(true);
          }, 3000);
        } else {
          setShowLoader(false);
          setSaveButtonDisabled(true);
          setSuccessMsg(true);

          setTimeout(() => {
            setSuccessMsg(false);
          }, 2000);
          setTimeout(() => {
            navigate("/send_sms_bulk_notifications");
          }, 3000);
          console.log("res", res);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleFile = (e) => {
    let file = null;
    file = e.target.files[0];
    const fileType = file.name.substring(
      file.name.lastIndexOf(".") + 1,
      file.name.length
    );
    if (
      file === null ||
      typeof file === "undefined" ||
      file === "" ||
      typeof file === undefined ||
      fileType.toLowerCase() !== "csv"
    ) {
      Swal.fire({
        text: "Please choose a valid .csv file.",
        confirmButtonText: `OK`,
        icon: "error",
      });
      file = null;
      console.log("bad file");
    } else {
      console.log([e.target.name], e.target.files[0]);

      setUnregisteredRetailers([]);
      setPasrsedSimilarDataLength(0);
      setPasrsedDifferentDataLength(0);

      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const checkValidHeader = Object.keys(results.data[0]);
          console.log("results======>", checkValidHeader);
          if (
            checkValidHeader.includes("COMPANYNAME") &&
            checkValidHeader.includes("SAPID") &&
            checkValidHeader.includes("DESCRIPTION")
          ) {
            const parseddata =
              props.permissions === "isSap"
                ? results.data.map((item, i) => ({
                    id: i,
                    value: item.COMPANYNAME + "-0000" + item.SAPID,
                    label: item.COMPANYNAME + "-0000" + item.SAPID,
                    sap: "0000" + item.SAPID.trim(),
                    sms_text: item.DESCRIPTION.trim(),
                  }))
                : results.data.map((item, i) => ({
                    id: i,
                    value: item.COMPANYNAME + " " + item.SAPID,
                    label: item.COMPANYNAME + " " + item.SAPID,
                    sap: item.SAPID.trim(),
                    sms_text: item.DESCRIPTION.trim(),
                  }));
            console.log(parseddata);
            let pasrsedSimilarData = [];
            let listWithPhoneNo = originalList.filter((e) => e.sap !== e.phone);
            pasrsedSimilarData = parseddata.filter((a1) =>
              listWithPhoneNo.some((a2) => a1.sap === a2.sap)
            );

            if (pasrsedSimilarData && pasrsedSimilarData.length) {
              const similarArray =
                saleOffList !== null
                  ? saleOffList.filter(
                      ({ sap: id1 }) =>
                        !pasrsedSimilarData.some(({ sap: id2 }) => id2 === id1)
                    )
                  : [];
              setSaleOffList([...similarArray, ...pasrsedSimilarData]);
              setPasrsedSimilarDataLength(pasrsedSimilarData.length);

              let descriptionCount = saleOffList.reduce(
                (acc, count) => acc + Math.ceil(count.sms_text.length / 160),
                0
              );
              setMessageCount(descriptionCount);
            }
            const pasrsedDifferentData = parseddata.filter((a1) =>
              pasrsedSimilarData.every((a2) => a1.sap !== a2.sap)
            );
            if (pasrsedDifferentData && pasrsedDifferentData.length) {
              console.log(pasrsedDifferentData, pasrsedDifferentData.length);
              // this.setState({ unregisteredRetailers: [...pasrsedDifferentData], pasrsedDifferentDataLength: pasrsedDifferentData.length })
              setUnregisteredRetailers([...pasrsedDifferentData]);
              setPasrsedDifferentDataLength(pasrsedDifferentData.length);
            }
            console.log("seprated", pasrsedSimilarData, pasrsedDifferentData);
            // this.setState({ parsedCSVdata: [...parseddata] });
            setParsedCSVdata([...parseddata]);
          } else {
            Swal.fire({
              text: "File headers do not match. Kindly download and refer the sample file.",
              confirmButtonText: `OK`,
              icon: "error",
            });
          }
        },
      });
    }
  };

  const onModalClose = () => {
    setShowModal(false);
  };

  // cancelClick = () => {
  //   this.setState({
  //     saleOffList: [],
  //     saleOffNameSapCode: originalList,
  //     unregisteredRetailers: [],
  //     pasrsedSimilarDataLength: 0,
  //     pasrsedDifferentDataLength: 0,
  //   });
  // }

  const toggleUnregisteredRetailers = () => {
    setUnregisteredRetailersToggle(!unregisteredRetailersToggle);
  };

  return (
    <div>
      <div className="notification-list-button">
        <ListButton basePath={props.basePath} />
      </div>
      <div className="so-form-container">
        <div className="so-form">
          <div className="so-input">
            <label>
              {translate(
                "resources.send_sms_bulk_notifications.fields.message_purpose"
              )}
              <sup>*</sup>
            </label>
            <input
              className="form-control"
              type="text"
              name="Purpose"
              value={inAppPurpose || ""}
              onChange={(e) => purposeChange(e)}
            />
            {validationPurposeError && (
              <p className="so-input-error">
                {translate(
                  "resources.send_sms_bulk_notifications.fields.enter_purpose"
                )}
              </p>
            )}
          </div>

          {/* <input type="file" id="file" onChange={this.handleFile} /> */}

          <div className="target-upload-container">
            <div className="csv-file-upload-container">
              <label>
                {translate(
                  "resources.send_sms_bulk_notifications.fields.upload_file"
                )}
              </label>
              {/* <input type="file" accept=".csv" name="flies[]" /> */}
              <input
                type="file"
                id="file"
                accept=".csv"
                onChange={(e) => handleFile(e)}
              />
              {showFileError && (
                <p className="complaint-file-error">
                  {translate(
                    "resources.send_sms_bulk_notifications.fields.choose_valid_file"
                  )}
                </p>
              )}
              <div className="valid-file-upload">
                <p>
                  {translate(
                    "resources.send_sms_bulk_notifications.fields.instruction"
                  )}
                </p>
                <ul>
                  <li>
                    {translate(
                      "resources.send_sms_bulk_notifications.fields.only_csv"
                    )}
                  </li>
                </ul>
              </div>
              <div className="upload-file-format-download">
                <p>
                  {translate(
                    "resources.send_sms_bulk_notifications.fields.get_format"
                  )}{" "}
                  <a
                    href="https://clickit-static-files-prod.s3.eu-west-1.amazonaws.com/fille_formats/bulk-sms-notification.csv"
                    target="_blank"
                  >
                    {translate(
                      "resources.send_sms_bulk_notifications.fields.click_here"
                    )}
                  </a>{" "}
                  {translate(
                    "resources.send_sms_bulk_notifications.fields.to_download"
                  )}
                </p>
              </div>
            </div>

            {pasrsedSimilarDataLength > 0 || pasrsedDifferentDataLength > 0 ? (
              <div className="csv-result-container">
                <label>
                  {translate(
                    "resources.send_sms_bulk_notifications.fields.csv_result"
                  )}
                </label>
                <div className="csv-result">
                  <p onClick={() => toggleUnregisteredRetailers()}>
                    {pasrsedSimilarDataLength}{" "}
                    {translate(
                      "resources.send_sms_bulk_notifications.fields.retailer_found"
                    )}{" "}
                    {pasrsedDifferentDataLength}{" "}
                    {translate(
                      "resources.send_sms_bulk_notifications.fields.retailer_unregister"
                    )}
                    {pasrsedDifferentDataLength > 0
                      ? " Click to view unregistererd retailers"
                      : ""}
                    {pasrsedDifferentDataLength > 0 ? (
                      <span
                        className={
                          unregisteredRetailersToggle
                            ? `icon-arrow_down`
                            : `icon-arrow_up`
                        }
                      />
                    ) : (
                      ""
                    )}
                  </p>
                  {pasrsedDifferentDataLength > 0 ? (
                    <div
                      className={
                        unregisteredRetailersToggle
                          ? `hide-unregistered`
                          : `show-unregistered`
                      }
                    >
                      <React.Fragment>
                        {unregisteredRetailers.map((item) => (
                          <p key={item.id}>{item.label}</p>
                        ))}
                      </React.Fragment>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {saleOffList !== null && (
              <div className="sms-total-cost">
                {" "}
                {translate(
                  "resources.send_sms_bulk_notifications.fields.total_cost"
                )}
                {messageCount}
              </div>
            )}

            {saleOffList.length > 0 && (
              <TableContainer component={Paper}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        {translate(
                          "resources.send_sms_bulk_notifications.fields.sold_to_id"
                        )}
                      </TableCell>
                      <TableCell>
                        {translate(
                          "resources.send_sms_bulk_notifications.fields.name"
                        )}
                      </TableCell>
                      <TableCell>
                        {translate(
                          "resources.send_sms_bulk_notifications.fields.message_count"
                        )}
                      </TableCell>
                      <TableCell>
                        {translate(
                          "resources.send_sms_bulk_notifications.fields.description"
                        )}
                      </TableCell>
                      {/* <TableCell style={{paddingRight:"60px"}} align="right" >Department</TableCell>   */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {saleOffList.map((s, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {s.sap}
                          </TableCell>
                          <TableCell>{s.value}</TableCell>
                          <TableCell>
                            {s.sms_text
                              ? Math.ceil(s.sms_text.length / 160)
                              : ""}
                          </TableCell>
                          <TableCell>{s.sms_text}</TableCell>
                          {/*
                            <TableCell style={{paddingRight:"114px"}} align="right">{p.Department}</TableCell>   */}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        </div>
        {saveButtonDisabled && (
          <div className="so-save-button">
            {/* <button className={(!inAppPurpose || validationPurposeError || !saleOffList) ? 'disable-save' : ''}
                disabled={validationPurposeError || !inAppPurpose || saleOffList.length === 0}
                onClick={() => this.formSave()}>Save</button> */}

            <button
              disabled={
                validationPurposeError ||
                !inAppPurpose ||
                saleOffList.length === 0
              }
              onClick={() => setShowModal(true)}
            >
              {translate("resources.send_sms_bulk_notifications.fields.save")}
            </button>
          </div>
        )}

        {showModal && (
          <Modal open={showModal} onClose={() => onModalClose()} center>
            <div className="on-setting-modal">
              <h6>
                {translate(
                  "resources.send_sms_bulk_notifications.fields.are_you_sure"
                )}
              </h6>
              <div className="on-setting-modal-buttons">
                <button onClick={() => onModalClose()}>
                  {translate(
                    "resources.send_sms_bulk_notifications.fields.cancel"
                  )}
                </button>
                <button
                  className={
                    !inAppPurpose || validationPurposeError || !saleOffList
                      ? "disable-save"
                      : ""
                  }
                  disabled={
                    validationPurposeError ||
                    !inAppPurpose ||
                    saleOffList.length === 0
                  }
                  onClick={() => formSave()}
                >
                  {translate("resources.send_sms_bulk_notifications.fields.ok")}
                </button>
              </div>
            </div>
          </Modal>
        )}

        {showLoader && <div className="save-loader" />}
        {successMsg && (
          <div className="so-updated">
            {translate("resources.send_sms_bulk_notifications.fields.success")}{" "}
          </div>
        )}
        {errorMsg && <div className="so-email-exist">{errorMsgText}</div>}
      </div>
    </div>
  );
};

export default BulkSendMessageCreate;
